import React from "react";
import { Link } from "react-router-dom";
import data from "../../data/brands/_shared/gso-car-accident-band.json";
import "./GsoCarAccidentBand.css";

/**
 * GSO car-accident band: heading + 4 service-icon cards.
 * Recreated from gaspineortho.com home elements:
 *   - data-id="257013d" (heading)
 *   - data-id="5074f27" (4 icon-link cards)
 * Rendered with our neumorphic styling.
 */
export default function GsoCarAccidentBand() {
  if (!data || !data.cards || data.cards.length === 0) return null;

  return (
    <section
      className="gso-car-accident-band section-padding"
      role="region"
      aria-label="Featured services"
    >
      <div className="container">
        <ul className="gso-car-accident-band__grid">
          {data.cards.map((card, i) => {
            const isExternal = /^https?:/i.test(card.href);
            const Tag = isExternal ? "a" : Link;
            const linkProps = isExternal
              ? { href: card.href, target: "_blank", rel: "noopener noreferrer" }
              : { to: card.href };

            return (
              <li key={i} className="gso-car-accident-band__item">
                <Tag
                  className="gso-car-accident-band__card"
                  aria-label={card.title}
                  {...linkProps}
                >
                  <span
                    className="gso-car-accident-band__icon"
                    aria-hidden="true"
                    dangerouslySetInnerHTML={{ __html: card.svg }}
                  />
                  <span className="gso-car-accident-band__title">{card.title}</span>
                </Tag>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
